import React, { useContext, useEffect } from 'react';
import _, { clone } from 'lodash';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import FooterStep from 'components/organism/PriceSimulator/FooterStep/FooterStep';

import IdentifyOpportunitiesStep from './steps/IdentifyOpportunitiesStep';
import PortfolioUpdateStep from './steps/PortfolioUpdateStep';
import { FilterContextData } from 'contexts/FilterContext';
import Loader from 'components/molecules/Loader';
import { calculateContainerHeight } from 'utils/helperMethods';
import GoalStep from './steps/GoalStep';
import { commonClassName } from 'components/pages/OportunityIdentification';
import { PriceSimulatorSteps } from 'utils/Enums';

function CreatePriceSimulator() {
    const {
        createSimulatorRef,
        currentStep,
        nextStepHandler,
        viewMode,
        simulationOutputLoading,
        saveScenarioLoading,
        scenarioId,
        fetchScenarioLoading,
    } = useContext(priceSimulatorDataContext);

    const { allDimAndAttributeTypeList, setIsGlobalFilterDisabled } = useContext(FilterContextData);

    useEffect(() => {
        if (currentStep > PriceSimulatorSteps.GOAL_STEP) {
            setIsGlobalFilterDisabled(true);
        }

        return () => {
            setIsGlobalFilterDisabled(false);
        };
    }, [currentStep]);

    //container height excluding price simulator header, footer,navbar
    const containerHeight = calculateContainerHeight(1, 16 * 4 + 52 + 80);

    const renderStepForm = () => {
        switch (currentStep) {
            case 1:
                return <GoalStep />;
            case 2:
                return <PortfolioUpdateStep />;
            case 3:
                return <IdentifyOpportunitiesStep />;
            default:
                break;
        }
    };

    return (
        <section
            className={` ${commonClassName} bg-white h-full relative`}
            style={{ minHeight: 'calc(100vh - 100px)' }}
            ref={createSimulatorRef}
            id={'create-simulator-ref'}
        >
            <div className="font-medium font-xl mb-1">Pricing Simulator</div>

            {allDimAndAttributeTypeList?.loading ? (
                <Loader />
            ) : (
                <>
                    {/* RENDER STEP */}
                    <div style={{ maxHeight: containerHeight, overflowY: 'auto', paddingRight: 6 }}>
                        {renderStepForm()}
                    </div>

                    {/* FOOTER  */}
                    {!fetchScenarioLoading && (
                        <FooterStep
                            isLastStepDisabled={simulationOutputLoading || saveScenarioLoading}
                            currentStep={currentStep}
                            viewMode={viewMode}
                            onNavigationClickHandler={nextStepHandler}
                            scenarioId={scenarioId}
                        />
                    )}
                </>
            )}
        </section>
    );
}

export default CreatePriceSimulator;
